import React, { useState } from 'react';
import axios from 'axios';
import {
  Box,
  Card,
  CardContent,
  TextField,
  Typography,
  Button,
  Avatar,
  Divider,
} from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import backgroundImage from '../assets/bg.PNG';
import logo from '../assets/logo.svg';
import { useNavigate } from 'react-router-dom'; // 🚨 Add this

const LoginPage = () => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [errors, setErrors] = useState({ email: '', password: '' });
  const [serverError, setServerError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const navigate = useNavigate(); // 🚨 For redirection

  const validate = () => {
    const newErrors = { email: '', password: '' };
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!formData.email) {
      newErrors.email = 'Email is required';
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = 'Enter a valid email address';
    }

    if (!formData.password) {
      newErrors.password = 'Password is required';
    }

    setErrors(newErrors);
    return !newErrors.email && !newErrors.password;
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: '' });
    setServerError('');
    setSuccessMessage('');
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  if (!validate()) return;

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/login.php`,
      formData,
      {
        headers: { 'Content-Type': 'application/json' },
      }
    );

    console.log('Login successful');
    console.log('User ID:', response.data.userId);

    setSuccessMessage('Login successful!');
    setServerError('');

    // ✅ Save to localStorage
    localStorage.setItem('email', formData.email);
    localStorage.setItem('role', response.data.user_type); // e.g., "admin", "staff"store_keeper
localStorage.setItem('userId', response.data.userId);


    // ✅ Store the user's full name
    if (response.data.user && response.data.user.full_name) {
      localStorage.setItem('userName', response.data.user.full_name);
    } else if (response.data.user && (response.data.user.first_name || response.data.user.surname)) {
      const fullName = `${response.data.user.surname || response.data.user.first_name} ${response.data.user.employee_other_names || response.data.user.other_names || ''}`.trim();
      localStorage.setItem('userName', fullName);
    } else {
      localStorage.setItem('userName', formData.email);
    }
    
    // Also store phone number if available
    if (response.data.user && response.data.user.phone) {
      localStorage.setItem('phoneNumber', response.data.user.phone);
    }

if (response.data.user_department) {
  localStorage.setItem('userDepartment', response.data.user_department);
}
    // ✅ Redirect based on role
    const role = response.data.user_type?.toLowerCase();
    if (role === 'hr') {
      navigate('/dashboard');
    } else if (role === 'hr_staff') {
      navigate('/dashboard_staff');
      } 
      
      else if (role === 'store_keeper') {
      navigate('/Dashboard_store_keeper');  
    }

     else if (role === 'auditor') {
      navigate('/Dashboard_auditor');  
    }
  else if (role === 'requisition_staff') {
      navigate('/Dashboard_HOD_requisition_staff');  
    }
    

     else if (role === 'account') {
      navigate('/Dashboard_accountant');  
    }
    
     else if (role === 'hod') {
      navigate('/Dashboard_hod');  
    }

 else if (role === 'gm') {
      navigate('/Dashboard_gm');  
    }


     else {
      // fallback route if role is unrecognized
      navigate('/');
    }
  } catch (error) {
    console.error('Login failed:', error);
    setSuccessMessage('');
    if (error.response && error.response.data) {
      setServerError(error.response.data.error || 'Login failed');
    } else {
      setServerError('Server error occurred.');
    }
  }
};

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backdropFilter: 'blur(6px)',
      }}
    >
      <Card
        sx={{
          width: 400,
          px: 4,
          py: 5,
          borderRadius: 6,
          boxShadow: 12,
          backgroundColor: 'rgba(255, 255, 255, 0.85)',
          backdropFilter: 'blur(4px)',
        }}
      >
        <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <img src={logo} alt="Logo" style={{ width: 120, marginBottom: 10 }} />
          <Typography
            variant="body1"
            sx={{
              fontFamily: 'Poppins, sans-serif',
              fontWeight: 500,
              color: '#37474F',
              fontSize: '0.95rem',
              letterSpacing: 4,
              textTransform: 'uppercase',
              mb: 3,
              textAlign: 'center',
            }}
          >
            Human Resource Management
          </Typography>

          <Avatar sx={{ bgcolor: '#C84646', mb: 2 }}>
            <LockOutlinedIcon />
          </Avatar>

          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold' }}>
            Sign In
          </Typography>

          <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 2, width: '100%' }}>
            <TextField
              label="Email Address"
              name="email"
              value={formData.email}
              onChange={handleChange}
              variant="outlined"
              margin="normal"
              fullWidth
              type="email"
              autoComplete="email"
              error={!!errors.email}
              helperText={errors.email}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 2,
                  backgroundColor: '#fafafa',
                },
              }}
            />
            <TextField
              label="Password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              variant="outlined"
              margin="normal"
              fullWidth
              type="password"
              autoComplete="current-password"
              error={!!errors.password}
              helperText={errors.password}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 2,
                  backgroundColor: '#fafafa',
                },
              }}
            />

            {serverError && (
              <Typography color="error" sx={{ mt: 1 }}>
                {serverError}
              </Typography>
            )}

            {successMessage && (
              <Typography color="success.main" sx={{ mt: 1 }}>
                {successMessage}
              </Typography>
            )}

            <Button
              type="submit"
              variant="contained"
              fullWidth
              size="large"
              sx={{
                mt: 3,
                textTransform: 'none',
                fontWeight: 'bold',
                borderRadius: 2,
                backgroundColor: '#C84646',
                '&:hover': {
                  backgroundColor: '#b33c3c',
                },
              }}
            >
              Login
            </Button>
          </Box>

          <Divider sx={{ my: 3, width: '100%' }} />

          <Typography variant="body2" color="text.secondary">
            © {new Date().getFullYear()} Elegante HRM. Designed by Elegantè IT.
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default LoginPage;
